module.exports = __webpack_public_path__ + "img/symbol_5.6a17b99f.png";